import "./logo.css";
const Logo = () => {
  return (
    <div className="logo">
      <p>TODISH</p>
    </div>
  );
};
export default Logo;
